export default {"src":"/_next/static/media/saas-product.d6df41fb.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};